import React from 'react';
import { computeShopByColorConfig } from './helpers';

import ShopByColorUI from './ui';

const ShopByColor = ({ tags }: { tags: string[] }) => {
  const config = computeShopByColorConfig({ tags });

  return config && <ShopByColorUI {...config} prependDivider={true} />;
};

export default ShopByColor;
